import View from "views/logic/views/View";
import { adjustFormat, toUTCFromTz } from "util/DateTime";
import { setGlobalOverrideTimerange } from "views/logic/slices/searchExecutionSlice";
import { setTimerange, executeActiveQuery } from "views/logic/slices/viewSlice";
import { selectActiveQuery, selectViewType } from "views/logic/slices/viewSelectors";
const onZoom = (from, to, userTz) => (dispatch, getState) => {
  const activeQuery = selectActiveQuery(getState());
  const viewType = selectViewType(getState());
  const newTimeRange = {
    type: "absolute",
    from: adjustFormat(toUTCFromTz(from, userTz), "internal"),
    to: adjustFormat(toUTCFromTz(to, userTz), "internal")
  };
  if (viewType === View.Type.Dashboard) {
    dispatch(setGlobalOverrideTimerange(newTimeRange)).then(() => dispatch(executeActiveQuery()));
  } else {
    dispatch(setTimerange(activeQuery, newTimeRange));
  }
  return false;
};
export default onZoom;
